import dashboard from './dashboard';
import business from './business';
import advertisements from './advertisements';
import dateFilter from './dateFilter';
import errors from './errors';
import advertisement from './advertisement';

export default {
  ...dashboard,
  ...business,
  ...advertisements,
  ...dateFilter,
  ...errors,
  ...advertisement,
};
